import { createFeatureSelector, createSelector } from '@ngrx/store';
import { countryFeatureKey, CountryState } from './country-reducer';

export const getFilterCountryState =
  createFeatureSelector<CountryState>(countryFeatureKey);

export const getCountryState = createSelector(
  getFilterCountryState,
  (state: CountryState) => state
);
